import React, { useState, useEffect } from 'react';
import './GameOverScreen.css';
import ConsciousnessTrendChart from './ConsciousnessTrendChart.js';
import useWindowSize from '../hooks/useWindowSize.js';
import { getUILoc } from '../utils/cardUtils.js';
import audioManager from '../utils/AudioManager.js';
import { BGMCategory, HUMAN_PLAYER_ID } from '../gameLogic/constants.js';

function GameOverScreen({ winnerName, onNewGame, onMainMenu, turnHistory, gameState, isTutorial, yonotsuneRewardModal }) {
  const { width } = useWindowSize();
  const [showRewardModal, setShowRewardModal] = useState(false);

  useEffect(() => {
    // 画面遷移後に勝利/敗北BGMを開始
    const isVictory = gameState?.winner === HUMAN_PLAYER_ID;
    audioManager.ensureCategoryBGM(BGMCategory.RESULT, { isVictory });
  }, [gameState]);

  // Conditionally set chart dimensions and padding based on screen width
  let chartWidth, chartHeight, chartPadding;
  if (width < 600) {
    chartWidth = width * 0.9;
    chartHeight = chartWidth * 0.6;
    chartPadding = 40; // Smaller padding for mobile
  } else if (width < 950) {
    chartWidth = width * 0.8;
    chartHeight = chartWidth * 0.5;
    chartPadding = 50; // Medium padding
  } else {
    chartWidth = 800;
    chartHeight = 400;
    chartPadding = 60; // Default padding
  }

  const handleNewGame = () => {
    audioManager.playSE('select');
    audioManager.ensureCategoryBGM(BGMCategory.BASIC);
    onNewGame();
  };

  const handleMainMenu = () => {
    audioManager.playSE('select');
    audioManager.ensureCategoryBGM(BGMCategory.BASIC);
    onMainMenu();
  };

  const isRoguelike = gameState?.isRoguelikeMode;

  return (
    <div className="game-over-screen game-over-container-dark">
      <div className="title-bg-animation"></div>
      <div className="title-scanline"></div>

      <h1 style={{ position: 'relative', zIndex: 20 }}>{getUILoc('SCREENS.GAME_OVER')}</h1>
      <h2 style={{ position: 'relative', zIndex: 20 }}>{getUILoc('LABELS.WINNER')}: {winnerName}</h2>

      <div className="chart-container" style={{ position: 'relative', zIndex: 20, backgroundColor: 'rgba(0,0,0,0.5)', padding: '20px', borderRadius: '8px', border: '1px solid var(--color-border)' }}>
        <h3 style={{ color: 'var(--color-accent)', fontFamily: 'monospace' }}>{getUILoc('LABELS.HISTORY_LOG')}</h3>
        <ConsciousnessTrendChart 
          turnHistory={turnHistory} 
          gameState={gameState}
          width={chartWidth}
          height={chartHeight}
          padding={chartPadding} // Pass padding as a prop
        />
      </div>

      <div className="game-over-buttons" style={{ position: 'relative', zIndex: 20 }}>
        {gameState?.isHypothesisMode ? (
          <button className="menu-button start-button" onClick={handleMainMenu}>
            {getUILoc('BUTTONS.BACK_TO_HYPOTHESIS')}
          </button>
        ) : !isRoguelike ? (
          <>
            <button className="menu-button start-button" onClick={handleNewGame}>
              {isTutorial ? getUILoc('BUTTONS.BACK_TUTORIAL') : getUILoc('BUTTONS.NEW_GAME')}
            </button>
            <button className="menu-button" onClick={handleMainMenu}>
              {getUILoc('BUTTONS.BACK_MAIN_MENU')}
            </button>
          </>
        ) : null}
        {isRoguelike && (
          <button className="menu-button start-button" onClick={() => setShowRewardModal(true)}>
            {getUILoc('YONOTSUNE.REWARD_SCREEN.CONTINUE')}
          </button>
        )}
      </div>

      {isRoguelike && showRewardModal && (
        <div className="yonotsune-reward-overlay">
          <div className="yonotsune-reward-content">
             {yonotsuneRewardModal}
          </div>
        </div>
      )}
    </div>
  );
}

export default GameOverScreen;
